import React, { useState } from 'react';
import styles from './prevnextpagination.module.scss'

export interface PrevNextInnerPaginationProps {
    readonly count: number;
    readonly onChangePage: (event: any, page: number) => void;
    readonly page: number;
}

interface PrevNextPaginationProps {
    readonly innerProps: PrevNextInnerPaginationProps;
    readonly columns: number;
    readonly totalPages: number;
    readonly data: any[];
}

const PrevNextPagination = ({columns, innerProps : {page , onChangePage}, totalPages, data} : PrevNextPaginationProps) => {

    const internalPage = Number(localStorage.getItem("UserSearchPageNumber"));

    const isFirstPage = internalPage === 0;
    const isLastPage = data.length < 10;
    const isSinglePage = isFirstPage && isLastPage;

    const handlePrevClick = (event: React.MouseEvent) => {
    if (!isFirstPage && !isSinglePage) {
      const newPage = internalPage === 2 ? 0 : internalPage - 1;
      localStorage.setItem("UserSearchPageNumber", String(newPage)); 
      onChangePage(event, newPage);
    }
  };
 
  const handleNextClick = (event: React.MouseEvent) => {
    if (!isLastPage && !isSinglePage) {
      const newPage = internalPage === 0 ? 2 : internalPage + 1;
      localStorage.setItem("UserSearchPageNumber", String(newPage)); 
      onChangePage(event, newPage);
    }
  };
 
  return (
    <td colSpan={columns} className={styles.simplePagination}>
      <div className={styles.paginationContainer}>
        <button
          className={styles.paginationButton}
          onClick={handlePrevClick}
          disabled={isFirstPage || isSinglePage}
          style={{ opacity: isFirstPage || isSinglePage ? 0.5 : 1 }}
        >
          <span className={styles.icon}>←</span>
          <span className={styles.text}>Previous</span>
        </button>
        
        <button
          className={styles.paginationButton}
          onClick={handleNextClick}
          disabled={isLastPage || isSinglePage}
          style={{ opacity: isLastPage || isSinglePage ? 0.5 : 1 }}
        >
          <span className={styles.text}>Next</span>
          <span className={styles.icon}>→</span>
        </button>
      </div>
    </td>
  );
};

export default PrevNextPagination;